/**
 * Created by Kieran on 16/08/2017.
 */


import EventBus from "../EventBus";


let TitleManager = {
  setTitle(title) {
    let encodedStr = title;
    let parser = new DOMParser;
    let dom = parser.parseFromString(
      '<!doctype html><body>' + encodedStr,
      'text/html');
    title = dom.body.textContent;
    EventBus.$emit('App::setCustomTitle', title);
  },
  replaceTitle(title) {
    let encodedStr = title;
    let parser = new DOMParser;
    let dom = parser.parseFromString(
      '<!doctype html><body>' + encodedStr,
      'text/html');
    title = dom.body.textContent;
    EventBus.$emit('App::setReplaceTitle', title);
  },
};

export default TitleManager;



// WEBPACK FOOTER //
// ./src/helpers/TitleManager/index.js